// extracted by mini-css-extract-plugin
export var container = "_dw-0";
export var segment = "_dw-2";
export var segmentActive = "_dw-3";
export var track = "_dw-1";